import { BigDisplay } from '../../types/BigDisplay';
import { greenCircleIcon, yellowCircleIcon, greyCircleIcon, editIcon } from '../../utils/images';
import './BigDisplaysStatus.scss';
import { useState } from 'react';
import { AssignLocationForm } from '../AssignLocationForm';
import { Location } from '../../types/Locations';


interface BigDisplaysStatusProps {
  displays: BigDisplay[];
  locations: Location[];
  onRefresh: () => void;
}

const getStatusIcon = (status: string) => {
  switch (status) {
    case "online":
    case "active":
      return greenCircleIcon;
    case "warning":
      return yellowCircleIcon;
    default:
      return greyCircleIcon;
  }
};

export const BigDisplaysStatus: React.FC<BigDisplaysStatusProps> = ({ displays, locations, onRefresh }) => {
  const [isAssignFormOpen, setIsAssignFormOpen] = useState(false);
  const [selectedDisplay, setSelectedDisplay] = useState<BigDisplay | null>(null);

  const handleEditClick = (display: BigDisplay) => {
    setSelectedDisplay(display);
    setIsAssignFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsAssignFormOpen(false);
    setSelectedDisplay(null);
  };

  const handleAssignSuccess = () => {
    onRefresh();
  };

  return (
    <>
      <div className="status">
        {/* REMOVE STATUS HEADER IF WANT TO USE TABS WITH LABELS, THIS WAS ADDED BECAUSE OF ESL ISSUE */}
        <div className="status-header">
          <div className="status-header--title">
            <h2 className="status-header--text">Display Status</h2>
          </div>

          <div className="status-legend">
            <div className="status-indicators">
              <img src={greenCircleIcon} alt="Icon" />
              <span className="status-indicator active">Active</span>
              <img src={yellowCircleIcon} alt="Icon" />
              <span className="status-indicator fault">Fault</span>
              <img src={greyCircleIcon} alt="Icon" />
              <span className="status-indicator inactive">Inactive</span>
            </div>
          </div>
        </div>
        <div className="table-container">
          <table>
            <thead>
              <tr className="status-table__row">
                <th className="status-table__header">Location</th>
                <th className="status-table__header">Display ID</th>
                <th className="status-table__header">Resolution</th>
                <th className="status-table__header">Android ID</th>
                <th className="status-table__header status-table__header-edit"></th>
              </tr>
            </thead>
            <tbody>
              {displays.map((display) => (
                <tr className="status-table__row-body" key={display.id}>
                  <td className="status-table__cell">
                    <div className="status-table__cell-container">
                      <img src={getStatusIcon('online')} alt="Status Icon" />
                      {display.location_code || 'inactive'}
                    </div>
                  </td>
                  <td className="status-table__cell">{display.id}</td>
                  <td className="status-table__cell">×</td>
                  <td className="status-table__cell">{display.android_id || 'N/A'}</td>
                  <td className="status-table__cell status-table__cell-edit">
                    <img
                      src={editIcon}
                      alt="Edit icon"
                      onClick={() => handleEditClick(display)}
                      style={{ cursor: 'pointer' }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {selectedDisplay && (
        <AssignLocationForm
          isOpen={isAssignFormOpen}
          onClose={handleCloseForm}
          locations={locations}
          item={selectedDisplay}
          itemType="display"
          onSuccess={handleAssignSuccess}
        />
      )}
    </>
  );
}; 